import PlatformSelectionContainer from './platform-selection.container';

export default PlatformSelectionContainer;
